import { CircleIcon, EmptyCircleIcon } from 'app/agriculture/icons';
import 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistorySectionRow.scss';
import { TrailCamHistoryRowDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistoryRowDisplay';
import { forwardRef, MouseEventHandler, useCallback, useContext } from 'react';
import {
    useTimelineDispatch,
    useTimelineViewMode,
} from 'app/agriculture/AgTimeline/context/TimelineContext';
import { AsideStateContext } from 'app/agriculture/components/ContentBox/context/AsideStateContextProvider';
import { ImageSnapshot } from 'app/agriculture/queries/devices/types/ImageSnapshot';

export const TrailCamHistorySectionRow = forwardRef<
    HTMLDivElement,
    {
        snapshot: ImageSnapshot;
        onClick?: MouseEventHandler<HTMLButtonElement>;
        isCurrent: boolean;
    }
>(function TrailCamHistorySectionRow(
    {
        isCurrent,
        snapshot,
        onClick = () => {
            /* do nothing */
        },
    },
    ref,
) {
    const { setInterval } = useTimelineDispatch();
    const { getNewVisibleInterval } = useTimelineViewMode();
    const { setIsAsideOpen } = useContext(AsideStateContext);

    const navigateToTimestamp = useCallback(
        (timestamp: Date | undefined) => {
            setInterval(getNewVisibleInterval(timestamp), { cursorTime: timestamp });
        },
        [setInterval, getNewVisibleInterval],
    );

    const openAside = useCallback(() => {
        setIsAsideOpen(true);
    }, [setIsAsideOpen]);

    return (
        <div className="TrailCamHistorySectionRow" ref={ref}>
            {isCurrent ? (
                <CircleIcon className="TrailCamHistorySectionRow__icon" />
            ) : (
                <EmptyCircleIcon className="TrailCamHistorySectionRow__icon" />
            )}
            <button
                data-testid={`TrailCamHistorySectionRowButton-${snapshot.id}`}
                onClick={(e) => {
                    navigateToTimestamp(snapshot.timestamp);
                    openAside();
                    onClick(e);
                }}
                className="TrailCamHistorySectionRow__button"
            >
                <TrailCamHistoryRowDisplay {...snapshot} />
            </button>
        </div>
    );
});
